import React from "react";
import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-4 py-16">
        <div className="glass rounded-3xl p-8">
          <XCircle className="w-12 h-12 text-magenta" />
          <h1 className="font-display text-5xl uppercase leading-[0.9] mt-4 grad-text-hot" data-testid="cancel-title">Payment cancelled.</h1>
          <p className="mt-3 text-text/80">No charge was made. Your ticket wasn't reserved. Give it another shot when you're ready.</p>
          <Link to="/" className="mt-6 btn-primary">Back to Events</Link>
        </div>
      </div>
    </Layout>
  );
}
